window.Vue = require('vue');

const c = (m) => m.default || m;

//Global
Vue.component('loader', c(require('./loader/loader.vue')));

//Topbar
Vue.component('topbar-unread-messages-counter', c(require('./topbar/unreadMessagesCount.vue')));
Vue.component('topbar-unread-notifications-counter', c(require('./topbar/unreadNotificationsCount.vue')));
Vue.component('topbar-unread-notifications-dropdown', c(require('./topbar/unreadNotifications.vue')));
Vue.component('topbar-unread-topics-dropdown', c(require('./topbar/unreadTopics.vue')));

//Sidebar
Vue.component('sidebar-unread-messages-counter', c(require('./sidebar/unreadMessagesCount.vue')));
Vue.component('sidebar-unread-notifications-counter', c(require('./sidebar/unreadNotificationsCount.vue')));
Vue.component('sidebar-unread-events-counter', c(require('./sidebar/unreadEventsCount.vue')));

//Messenger
Vue.component('make-messages-as-read', c(require('./admin/messenger/makeMessagesAsRead.vue')));

//Notifications
Vue.component('make-notification-as-read', c(require('./admin/notifications/makeNotificationAsRead.vue')));

//Widgets
Vue.component('latest-notifications', c(require('./widgets/latestNotifications.vue')));

//Discussion
Vue.component('model-discussion', c(require('./admin//discussion/modelDiscussion.vue')));

// Projects (lazy – used only on specific pages)
Vue.component('projects-division', () => import('./projects-division/projectsDivision.vue'));
Vue.component('projects-column', () => import('./projects-division/projectsColumn.vue'));
Vue.component('developers-planning', () => import('./developers-planning/developersPlanning.vue'));
Vue.component('developers-planning-header', () => import('./developers-planning/developersPlanningHeader.vue'));
Vue.component('developers-planning-calendar-header', () => import('./developers-planning/developersPlanningCalendarHeader.vue'));
Vue.component('developers-planning-employe-row', () => import('./developers-planning/developersPlanningEmployeRow.vue'));

// Tasks — sidebar nel bundle principale (evita mismatch manifest.js ↔ chunk task-detail-sidebar.js in deploy)
Vue.component('task-detail-sidebar', c(require('./tasks/TaskDetailSidebar.vue')));

// Meetings (lazy – used only on meeting pages)
Vue.component('audio-recorder', () => import('./meetings/AudioRecorder.vue'));
Vue.component('recording-coach-page', c(require('./recording-coach/RecordingCoachPage.vue')));

// Workflows (lazy – used only on workflow pages)
Vue.component('workflow-list', () => import('./workflows/WorkflowList.vue'));
Vue.component('workflow-builder', () => import('./workflows/WorkflowBuilder.vue'));
Vue.component('workflow-logs', () => import('./workflows/WorkflowLogs.vue'));
Vue.component('workflow-step-card', () => import('./workflows/WorkflowStepCard.vue'));
Vue.component('condition-builder', () => import('./workflows/ConditionBuilder.vue'));
Vue.component('action-configurator', () => import('./workflows/ActionConfigurator.vue'));

// Quotes — review commerciale unificata (flag ON)
Vue.component('quote-commercial-editor', c(require('./quotes/QuoteCommercialEditor.vue')));
